import { render, staticRenderFns } from "./SearchToggleField.vue?vue&type=template&id=0c467258"
import script from "./SearchToggleField.vue?vue&type=script&lang=js"
export * from "./SearchToggleField.vue?vue&type=script&lang=js"
import style0 from "./SearchToggleField.vue?vue&type=style&index=0&id=0c467258&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports